import {
	type AutocompleteProps,
	Autocomplete as BaseAutocomplete,
	Spinner,
} from "@heroui/react";

import { useFieldContext, useLanguage } from "@onesolution/hooks";

import Chip from "../Chip";
import { OpenMode } from "../FormDrawer/FormDrawer";
import {
	defaultAutocompleteItemsRender,
	shouldDisplayItemPicker,
} from "./tools";

export function Autocomplete(
	props: Omit<AutocompleteProps, "children"> & {
		children?: AutocompleteProps["children"];
	},
) {
	const field = useFieldContext<string>();
	const { t } = useLanguage();

	if (
		!shouldDisplayItemPicker(props.isLoading, props.items || props.defaultItems)
	)
		return null;

	const mode = field.form.state.values.formOpenMode as OpenMode;

	if (mode === OpenMode.details)
		return (
			<div className="flex gap-2">
				{props.label ? (
					<h6 className="w-max text-foreground-500">{props.label} :</h6>
				) : null}
				{props.isLoading ? (
					<Spinner size="sm" />
				) : (
					<Chip>
						{
							(props.items as Array<{ key: string; name: string }>)?.find(
								(item) => item.key === field.state.value,
							)?.name
						}
					</Chip>
				)}
			</div>
		);

	return (
		<BaseAutocomplete
			placeholder="None"
			aria-label="autocomplete"
			labelPlacement="outside-top"
			defaultSelectedKey={field.state.value}
			value={field.state.value}
			selectedKey={field.state.value}
			onBlur={field.handleBlur}
			errorMessage={t("message.required")}
			onSelectionChange={(selection) => field.handleChange(selection as string)}
			{...props}
			defaultItems={props.defaultItems || []}
		>
			{props.children || defaultAutocompleteItemsRender}
		</BaseAutocomplete>
	);
}
